import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesActorsUsersRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-actors-users',
	path: '/secure/project/UserRoleActorAction.jspa',
};
